/**
 * Cắt về hai chữ số thập phân — KHÔNG làm tròn.
 *
 * Công thức `Math.floor(v * 100) / 100` đang được chép tay ~14 chỗ trong
 * `AdminPageV2.jsx` và `StudentPageV2.jsx`. Đợt làm lại giao diện sẽ gom về một
 * chỗ, và đây là chỗ đó.
 *
 * Vì sao phải là CẮT chứ không phải `toFixed(2)`: trang dùng hai kiểu làm tròn
 * ngược nhau, có chủ ý.
 *   - Quãng đường ĐÃ ĐẠT thì cắt xuống — không khoe hơn thực tế.
 *   - Số CÒN THIẾU thì làm tròn lên (`Math.ceil` trong `checkDATConditions`)
 *     — không báo thiếu ít hơn thực tế.
 * Cả hai đều nghiêng về phía an toàn cho một kết luận có giá trị pháp lý.
 * `toFixed(2)` làm tròn hai chiều, nên thay vào đây sẽ đổi kết luận của học
 * viên nằm sát ngưỡng, mà không có gì báo lỗi. Xem `dinhDangSo.test.js`.
 *
 * @param {number|string|null|undefined} v
 * @returns {number} 0 khi không có giá trị — khớp nhánh `params.value ? … : 0`
 *                   mà các valueFormatter đang dùng.
 */
export function catHaiChuSo(v) {
  return v ? Math.floor(v * 100) / 100 : 0;
}
